module.exports = __webpack_public_path__ + "static/media/facebookIcon.96553326.svg";